var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0-Base/icons/arrow-right",
    transform: "translate(0.000000, -1.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9319303,14.1747807 L12.9317294,23.6035626 C12.6852954,23.8553539 12.3531451,24 11.9995658,24 C11.6459864,24 11.3116933,23.8559968 11.0684736,23.6015268 L2.06827266,14.1727449 C1.57969033,13.6122681 1.59811931,12.8461796 2.11209507,12.3533115 C2.621035,11.8628005 3.43801752,11.8812295 3.93034994,12.3968392 L10.7138228,19.5052568 L10.7138228,1.28627871 C10.7138228,0.576441438 11.2897285,0 11.9513504,0 C12.6129723,0 13.2853088,0.576441438 13.2853088,1.28627871 L13.2853088,19.5063283 L20.067603,12.397241 C20.558114,11.8816045 21.3753108,11.8631755 21.8858579,12.3537133 C22.4033694,12.8461796 22.4194412,13.6122681 21.9319303,14.1747807 Z",
    id: "Path",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) rotate(90.000000) translate(-12.000000, -12.000000) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.7d5170c40bcfd9fb8eac31c8326c02da.svg";
export { ForwardRef as ReactComponent };